/** Marketing copy aligned with https://zordigo.com/pricing.html */

export const PRICING_PLAN_COPY = {
    starter: {
        title: "Starter Plan",
        tagline: "Powerful & Awesome Features",
        priceNote: null,
        priceMain: "Free",
        priceSub: "Forever",
        featured: false,
        features: [
            { label: "Upto 2 Drivers", included: true },
            { label: "Upto 1 Packer", included: true },
            { label: "Upto 1 Dispatcher", included: true },
            { label: "Live Tracking", included: false },
            { label: "Account Report", included: true },
            { label: "Proof of Delivery", included: true },
            { label: "Location History", included: false },
            { label: "WhatsApp Order Updates", included: false, mark: "*" },
            { label: "300 Free Orders / Month", included: true, mark: "**" },
            { label: "Customization (Extra Charges)", included: false },
        ],
        terms: [
            { mark: "*", text: "WhatsApp Order Updates available at additional charges." },
            { mark: "**", text: "Free upto 300 orders / month, after ₹0.79 (79 paise) per order." },
        ],
    },
    advance: {
        title: "Advance Plan",
        tagline: "Full Feature Access",
        priceNote: "First month free*",
        priceMain: "₹799",
        priceSub: "/ Month after",
        featured: true,
        features: [
            { label: "Upto 8 Drivers", included: true },
            { label: "Upto 2 Packers", included: true },
            { label: "Upto 2 Dispatchers", included: true },
            { label: "Live Tracking", included: true },
            { label: "Account Report", included: true },
            { label: "Proof of Delivery (1-Year Storage)", included: true },
            { label: "7-Day Location History", included: true },
            { label: "WhatsApp Order Updates", included: true, mark: "**" },
            { label: "1,150 Free Orders / Month", included: true, mark: "***" },
            { label: "Customization (Extra Charges)", included: true },
        ],
        terms: [
            { mark: "*", text: "First full month free on the Advance Plan for new users only. Then ₹799 / month." },
            { mark: "**", text: "WhatsApp Order Updates available at additional charges." },
            { mark: "***", text: "Free upto 1,150 orders / month, after ₹0.69 (69 paise) per order. No charges for cancelled / failed bills." },
        ],
    },
    enterprise: {
        title: "Enterprise",
        tagline: "Best for large-scale operations",
        priceNote: null,
        priceMain: "Custom",
        priceSub: null,
        featured: false,
        features: [
            { label: "Unlimited Orders", included: true },
            { label: "Full Analytics Suite", included: true },
            { label: "Custom Integrations", included: true },
            { label: "Dedicated Priority Support", included: true },
        ],
        terms: [],
    },
};

export function getPricingPlanKey(plan) {
    const n = String(plan?.planName || "").toLowerCase();
    if (plan?.isCustom || n === "custom" || n.includes("enterprise")) return "enterprise";
    if (n.includes("advance")) return "advance";
    if (n.includes("starter")) return "starter";
    return "starter";
}

export function getPricingPlanCopy(plan) {
    return PRICING_PLAN_COPY[getPricingPlanKey(plan)];
}
